export const ListQueryKey = 'projectAccountLogins';
export const DetailQueryKey = 'projectAccountLogin';

export const Urls = {
  selectUrl: '/accountloginlog/list',
  updateUrl: '/accountloginlog/update',
  deleteUrl: '/accountloginlog/delete',
  createUrl: '/accountloginlog/create',
  detailUrl: '/accountloginlog/info',
};
